
'use client';

import React from 'react';
import DesktopHeader from './DesktopHeader';
import BottomNav from './BottomNav';

interface ResponsiveShellProps {
  children: React.ReactNode;
}

export default function ResponsiveShell({ children }: ResponsiveShellProps) {
  return (
    <div className="min-h-screen bg-[#F8FAFC] flex flex-col">
      {/* Global Desktop Header - only visible on md+ */}
      <DesktopHeader />

      {/* Main Content Area */}
      <main className="flex-1 w-full mx-auto max-w-[1600px] md:pt-28 pb-statement-bar md:pb-12">
        <div className="w-full px-3 sm:px-4 md:px-8">
          {children}
        </div>
      </main>

      {/* Global Mobile Bottom Navigation - only visible on <md */}
      <BottomNav />
    </div>
  );
}
